import React, {useCallback, useState} from 'react';
import parse from 'html-react-parser';
import Button from 'js/components/Common/Button/Button';
import Heading from 'js/components/Common/Heading/Heading';
import useFetchData from 'js/hooks/useFetchData/useFetchData';
import Container from 'js/components/Common/Container/Container';
import DataValidator from 'js/components/Common/DataValidator/DataValidator';

import fetchData from './fetchData';
import classes from './Training.module.pcss';
import MixPanelWrapper from 'js/servises/MixPanelWrapper';

interface Props {
    pageId: number
}

type ListItemType = {
	title: string,
	description: string
}

type ButtonDataType = {
	text: string,
	url: string
}

const Training = ({pageId}: Props) => {
    const [title, setTitle] = useState<string>('');
    const [list, setList] = useState<Array<ListItemType>>(null);
	const [button, setButton] = useState<ButtonDataType>(null);

    const {isLoading, error} = useFetchData({
        query: `${fetchData(pageId)}`,
        condition: !!pageId,
        updateData: (data: any): void => {
			const result = data?.page?.PostLoginPage;
			setTitle(result?.trainingTitle);
			setList(result?.trainingInfo);
			setButton({
				text: result?.buttonTextTraining,
				url: result?.buttonLinkTraining?.uri
			});
        }
    });

	const sendMixClickEvent = useCallback(async () => (
		await MixPanelWrapper.TrackEvent(
			'CTA Button is clicked on',
			{
				category: 'Home page',
				section: 'Training section'
			})
	), []);

    return (
        <DataValidator data={!isLoading && !error && list?.length > 0}>
            <section className={`${classes.Training} ${list?.length === 1 ? classes.Singular : ''}`}>
				<Container>
					<Heading text={title} />
					<div className={classes.List}>
						{list?.map((item, index) =>
							<div className={classes.ListItem} key={index}>
								<Heading text={item?.title} type={'h4'}/>
								{parse(item?.description || '')}
								{list?.length === 1 ? <div className={classes.Wrap}>
									<Button
										type={'a'}
										buttonType={'ButtonColored'}
										buttonColorType={'Pink'}
										text={button?.text}
										link={`/${button?.url}`}
										handler={async () => sendMixClickEvent()}
									/>
								</div> : ''}
							</div>
						)}
					</div>
					{list?.length > 1 ?
						<div className={classes.Wrap}>
							<Button
								type={'a'}
								buttonType={'ButtonColored'}
								buttonColorType={'Pink'}
								text={button?.text}
								link={`/${button?.url}`}
								handler={async () => sendMixClickEvent()}
							/>
						</div> : ''
					}
				</Container>
			</section>
		</DataValidator>
	);
};

export default Training;
